// extracted by mini-css-extract-plugin
export default {"saveSearchButton":"SavedSearchButton_saveSearchButton__R4Wj+","saveSearchText":"SavedSearchButton_saveSearchText__dRVOh"};